import React from 'react';
import { TrendingUpIcon, ZapIcon, CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
export function HeroB2B() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-white pt-12 md:pt-20 pb-16 md:pb-24" data-id="element-776">
      <div className="container mx-auto max-w-7xl px-4" data-id="element-777">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-778">
          {/* Contenido */}
          <div className="space-y-6" data-id="element-779">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#2B5FD9]/10 rounded-full" data-id="element-780">
              <TrendingUpIcon className="h-4 w-4 text-[#2B5FD9]" data-id="element-781" />
              <span className="text-sm font-semibold text-[#2B5FD9]" data-id="element-782">
                Para Corredores e Inmobiliarias
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0A1628] leading-tight" data-id="element-783">
              Cierra más ventas con créditos más rápidos
            </h1>

            <p className="text-lg md:text-xl text-[#6B7280] leading-relaxed" data-id="element-784">
              Creditual acelera el proceso de aprobación de créditos
              hipotecarios de tus clientes.
              <strong className="text-[#0A1628]" data-id="element-785">
                {' '}
                Menos tiempo de espera, más ventas concretadas.
              </strong>
            </p>

            <div className="space-y-3" data-id="element-786">
              <div className="flex items-start gap-3" data-id="element-787">
                <CheckCircle2Icon className="h-6 w-6 text-[#2B5FD9] flex-shrink-0 mt-0.5" data-id="element-788" />
                <div data-id="element-789">
                  <p className="font-semibold text-[#0A1628]" data-id="element-790">
                    Aprobaciones en días, no semanas
                  </p>
                  <p className="text-sm text-[#6B7280]" data-id="element-791">
                    Reduce el tiempo de cierre de 4-6 semanas a 7-10 días
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-792">
                <CheckCircle2Icon className="h-6 w-6 text-[#2B5FD9] flex-shrink-0 mt-0.5" data-id="element-793" />
                <div data-id="element-794">
                  <p className="font-semibold text-[#0A1628]" data-id="element-795">
                    Menos clientes perdidos
                  </p>
                  <p className="text-sm text-[#6B7280]" data-id="element-796">
                    Evita que tus compradores se cansen de esperar y abandonen
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-797">
                <CheckCircle2Icon className="h-6 w-6 text-[#2B5FD9] flex-shrink-0 mt-0.5" data-id="element-798" />
                <div data-id="element-799">
                  <p className="font-semibold text-[#0A1628]" data-id="element-800">
                    Sin costo para ti
                  </p>
                  <p className="text-sm text-[#6B7280]" data-id="element-801">
                    Servicio gratuito para corredores e inmobiliarias
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-802">
              <button onClick={() => scrollToSection('contacto-b2b')} className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#2B5FD9] text-white text-lg font-semibold rounded-xl hover:bg-[#1E4BB8] hover:-translate-y-1 transition-all shadow-lg hover:shadow-xl" data-id="element-803">
                <span data-id="element-804">Quiero acelerar mis ventas</span>
                <ArrowRightIcon className="h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-805" />
              </button>
              <button onClick={() => scrollToSection('beneficios-b2b')} className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white border-2 border-[#2B5FD9] text-[#2B5FD9] text-lg font-semibold rounded-xl hover:bg-[#2B5FD9]/5 transition-all" data-id="element-806">
                Ver beneficios
              </button>
            </div>
          </div>

          {/* Visual */}
          <div className="relative" data-id="element-807">
            <div className="relative bg-gradient-to-br from-[#2B5FD9]/10 to-purple-500/10 rounded-3xl p-8 md:p-12" data-id="element-808">
              {/* Stats cards */}
              <div className="space-y-4" data-id="element-809">
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100" data-id="element-810">
                  <div className="flex items-center justify-between mb-4" data-id="element-811">
                    <span className="text-sm font-medium text-[#6B7280]" data-id="element-812">
                      Tiempo de cierre
                    </span>
                    <ZapIcon className="h-5 w-5 text-green-600" data-id="element-813" />
                  </div>
                  <div className="space-y-2" data-id="element-814">
                    <div className="flex items-center justify-between" data-id="element-815">
                      <span className="text-xs text-[#6B7280]" data-id="element-816">Antes</span>
                      <span className="text-sm font-bold text-red-600" data-id="element-817">
                        4-6 semanas
                      </span>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-818">
                      <span className="text-xs text-[#6B7280]" data-id="element-819">
                        Con Creditual
                      </span>
                      <span className="text-lg font-bold text-green-600" data-id="element-820">
                        7-10 días
                      </span>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100" data-id="element-821">
                  <div className="flex items-center justify-between mb-4" data-id="element-822">
                    <span className="text-sm font-medium text-[#6B7280]" data-id="element-823">
                      Tasa de conversión
                    </span>
                    <TrendingUpIcon className="h-5 w-5 text-[#2B5FD9]" data-id="element-824" />
                  </div>
                  <div className="flex items-baseline gap-2" data-id="element-825">
                    <span className="text-4xl font-bold text-[#2B5FD9]" data-id="element-826">
                      +35%
                    </span>
                    <span className="text-sm text-[#6B7280]" data-id="element-827">
                      más ventas cerradas
                    </span>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-2xl p-6 shadow-lg text-white" data-id="element-828">
                  <p className="text-sm opacity-90 mb-2" data-id="element-829">
                    Clientes satisfechos
                  </p>
                  <p className="text-3xl font-bold mb-1" data-id="element-830">98%</p>
                  <p className="text-xs opacity-75" data-id="element-831">recomiendan Creditual</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}